export default __webpack_public_path__ + "static/media/stakeTkn.00ac9b7c.svg";